import { defineStore } from 'pinia'
import type { FactorAuthentication } from './machine'
import type { AccountState } from './machine-account'
// machine에서 data 가져오기 번거로워서 store로 만듦
export const useAuth = defineStore('auth', {
  state: () => ({
    factor: 'determiningUserType' as FactorAuthentication,
    accountStatus: undefined as AccountState | undefined,
    accessToken: undefined as string | undefined,
    refreshToken: undefined as string | undefined,
    name: undefined as string | undefined,
    id: undefined as string | undefined,
    userLevel: undefined as string | undefined,
    partnerName: undefined as string | undefined,
  }),
})
